import { FormerMemberBankingStatements } from '../../../../former-member/components/FormerMemberBankingStatements';

export default function FormerMemberBankingStatementsPage() {
    return <FormerMemberBankingStatements />;
}
